/**
 * =====================================================================
 * DEPRECIATION TAB - Post Monthly Depreciation
 * =====================================================================
 *
 * This is extracted from the original PostDepreciation.tsx page.
 * For now, it imports and wraps the existing PostDepreciation component.
 * In the future, this can be refactored to a pure component.
 *
 * =====================================================================
 */

import React from 'react'
import { AdminUser } from '@/lib/authService'
import PostDepreciation from '@/pages/finance/PostDepreciation'

interface DepreciationTabProps {
  user: AdminUser | null
  refreshTrigger: number
  onDataChange: () => void
}

export default function DepreciationTab({ user, refreshTrigger, onDataChange }: DepreciationTabProps) {
  // For now, we'll render the existing PostDepreciation component
  // The header is already in the parent unified page, so we might want to hide it
  return <PostDepreciation user={user} />
}
